import moment, { Moment } from 'moment';
import { shortcutOptionItemType } from '../_type';

// 定义接口
export interface DateShortcutType {
  name: string;
  type: string;
  nameCN: string;
  event_type_name_en:string;
  isGroup?:boolean;
  onClick: () => Array<Moment | null>;
}

export interface ShortcutOptionType {
  [type: string]: DateShortcutType[];
}


// startOfTime和latestDate，不是所有地方都需要，需要从外部传入参数
export const shortcutOptionDefualt = (startOfTime: string, latestDate: any, seasonInfo: any, dispatch: any): ShortcutOptionType => {
  const { date, month, week } = latestDate || {};

  const latestDataObj = {
    name: 'Latest Data',
    nameCN: '最新数据',
  };
  const allOfTimeObj = {
    name: 'All of time',
    nameCN: '所有时间',
  };

  const setFilterSaveDurationFunc = (data: shortcutOptionItemType) => {
    dispatch({
      type: 'dashboardSetting/setFilterSaveDuration',
      payload: {
        data,
      },
    });
  };

  const latestDateData = {
    ...latestDataObj,
    type: 'lasteDateDate',
    value: [moment(date), moment(date)],
    timeType: 'date',
    onClick: () => {    
      setFilterSaveDurationFunc({
        ...latestDataObj,
        type: 'lasteDateDate'
      });
      return [moment(date), moment(date)];
    }
  };
  const latestWeekData = {
    ...latestDataObj,
    type: 'lasteDateWeek',
    timeType: 'week',
    value: [moment(week).weekday(0), moment(week).weekday(6)],
    onClick: () => {
      setFilterSaveDurationFunc({
        ...latestDataObj,
        type: 'lasteDateWeek'
      });
      return [moment(week).weekday(0), moment(week).weekday(6)];
    }
  };
  const latestMonthData = {
    ...latestDataObj,
    type: 'lasteDateMonth',
    timeType: 'month',
    value: [moment(month).subtract(0, 'month').startOf('month'), moment(month).subtract(0, 'month').endOf('month')],
    onClick: () => {
      setFilterSaveDurationFunc({
        ...latestDataObj,
        type: 'lasteDateMonth',
      });
      return [moment(month).subtract(0, 'month').startOf('month'), moment(month).subtract(0, 'month').endOf('month')];
    }
  };

  const allDateOfTime = {
    ...allOfTimeObj,
    type: 'allOfTimeDate',
    timeType: 'date',
    value: [moment(startOfTime), moment().subtract(1, 'day')],
    onClick: () => {
      setFilterSaveDurationFunc({
        ...allOfTimeObj,
        type: 'allOfTimeDate',
      });
      return [moment(startOfTime), moment().subtract(1, 'day')];
    }
  };
  const allWeekOfTime = {
    ...allOfTimeObj,
    type: 'allOfTimeWeek',
    timeType: 'week',
    value: [moment(startOfTime).startOf('week'), moment().weekday(6)],
    onClick: () => {
      setFilterSaveDurationFunc({
        ...allOfTimeObj,
        type: 'allOfTimeWeek',
      });
      return [moment(startOfTime).startOf('week'), moment().weekday(6)];
    }
  };
  const allMonthOfTime = {
    ...allOfTimeObj,
    type: 'allOfTimeMonth',
    timeType: 'month',
    value: [moment(startOfTime), moment().endOf('month')],
    onClick: () => {
      setFilterSaveDurationFunc({
        ...allOfTimeObj,
        type: 'allOfTimeMonth',
      });
      return [moment(startOfTime), moment().endOf('month')];
    }
  };

  let dateArray = [
    {
      name: 'Last 7 Days',
      type: 'last7Days',
      timeType: 'date',
      nameCN: '最近7天',
      value: [moment().subtract(7, 'day'), moment().subtract(1, 'day')],
      onClick: () => {
        setFilterSaveDurationFunc({
          name: 'Last 7 Days',
          type: 'last7Days',
          nameCN: '最近7天',
        });
        return [moment().subtract(7, 'day'), moment().subtract(1, 'day')];
      }
    },
    {
      name: 'Last 28 Days',
      type: 'last28Days',
      timeType: 'date',
      nameCN: '最近28天',
      value: [moment().subtract(28, 'day'), moment().subtract(1, 'day')],
      onClick: () => {
        setFilterSaveDurationFunc({
          name: 'Last 28 Days',
          type: 'last28Days',
          nameCN: '最近28天',
        });
        return [moment().subtract(28, 'day'), moment().subtract(1, 'day')];
      }
    },
    {
      name: 'Last 30 Days',
      nameCN: '最近30天',
      type: 'last30Days',
      timeType: 'date',
      value: [moment().subtract(30, 'day'), moment().subtract(1, 'day')],
      onClick: () => {
        setFilterSaveDurationFunc({
          name: 'Last 30 Days',
          nameCN: '最近30天',
          type: 'last30Days',
        });
        return [moment().subtract(30, 'day'), moment().subtract(1, 'day')];
      }
    },
    {
      name: 'Last 90 Days',
      nameCN: '最近90天',
      type: 'last90Days',
      timeType: 'date',
      value: [moment().subtract(90, 'day'), moment().subtract(1, 'day')],
      onClick: () => {
        setFilterSaveDurationFunc({
          name: 'Last 90 Days',
          nameCN: '最近90天',
          type: 'last90Days',
        });
        return [moment().subtract(90, 'day'), moment().subtract(1, 'day')];
      }
    },
    {
      name: 'Last 180 Days',
      nameCN: '最近180天',
      type: 'last180Days',
      timeType: 'date',
      value: [moment().subtract(180, 'day'), moment().subtract(1, 'day')],
      onClick: () => {
        setFilterSaveDurationFunc({
          name: 'Last 180 Days',
          nameCN: '最近180天',
          type: 'last180Days',
        });
        return [moment().subtract(180, 'day'), moment().subtract(1, 'day')];
      }
    },
    {
      name: 'Last 365 Days',
      nameCN: '最近365天',
      type: 'last365Days',
      timeType: 'date',
      value: [moment().subtract(365, 'day'), moment().subtract(1, 'day')],
      onClick: () => {
        setFilterSaveDurationFunc({
          name: 'Last 365 Days',
          nameCN: '最近365天',
          type: 'last365Days',
        });
        return [moment().subtract(365, 'day'), moment().subtract(1, 'day')];
      }
    },
    {
      name: 'Month to Date',
      nameCN: '本月',
      type: 'monthToDate',
      timeType: 'date',
      value: [moment().startOf('month'), moment().subtract(1, 'day')],
      onClick: () => {
        setFilterSaveDurationFunc({
          name: 'Month to Date',
          nameCN: '本月',
          type: 'monthToDate',
        });
        return [moment().startOf('month'), moment().subtract(1, 'day')];
      }
    },
    {
      name: 'Year to Date',
      nameCN: '今年',
      type: 'yearToDate',
      timeType: 'date',
      value: [moment().startOf('year'), moment().subtract(1, 'day')],
      onClick: () => {
        setFilterSaveDurationFunc({
          name: 'Year to Date',
          nameCN: '今年',
          type: 'yearToDate',
        });
        return [moment().startOf('year'), moment().subtract(1, 'day')];
      }
    },
  ];

  let weekArray = [
    {
      name: 'Last 4 Weeks',
      nameCN: '最近4周',
      type: 'last4Weeks',
      timeType: 'week',
      value: [moment().weekday(-7 * 4), moment().weekday(-1)],
      onClick: () => {
        setFilterSaveDurationFunc({
          name: 'Last 4 Weeks',
          nameCN: '最近4周',
          type: 'last4Weeks',
        });
        return [moment().weekday(-7 * 4), moment().weekday(-1)];
      }
    },
    {
      name: 'Last 12 Weeks',
      nameCN: '最近12周',
      type: 'last12Weeks',
      timeType: 'week',
      value: [moment().weekday(-7 * 12), moment().weekday(-1)],
      onClick: () => {
        setFilterSaveDurationFunc({
          name: 'Last 12 Weeks',
          nameCN: '最近12周',
          type: 'last12Weeks',
        });
        return [moment().weekday(-7 * 12), moment().weekday(-1)];
      }
    },
    {
      name: 'Last 24 Weeks',
      nameCN: '最近24周',
      type: 'last24Weeks',
      timeType: 'week',
      value: [moment().weekday(-7 * 24), moment().weekday(-1)],
      onClick: () => {
        setFilterSaveDurationFunc({
          name: 'Last 24 Weeks',
          nameCN: '最近24周',
          type: 'last24Weeks',
        });
        return [moment().weekday(-7 * 24), moment().weekday(-1)];
      }
    },
    {
      name: 'Year to Date',
      nameCN: '今年',
      type: 'yearToWeek',
      timeType: 'week',
      value: [moment().startOf('year').startOf('week'), moment().weekday(6)],
      onClick: () => {
        setFilterSaveDurationFunc({
          name: 'Year to Date',
          nameCN: '今年',
          type: 'yearToWeek',
        });
        // 取末尾为本周日，如果语言环境修改了每周的起始时间（moment.locale(）），则需重新修改
        return [moment().startOf('year').startOf('week'), moment().weekday(6)];
      }
    },
  ];

  let monthArray = [
    {
      name: 'Last 3 Months',
      nameCN: '最近3个月',
      type: 'last3Months',
      timeType: 'month',
      value: [moment().subtract(3, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
      onClick: () => {
        setFilterSaveDurationFunc({
          name: 'Last 3 Months',
          nameCN: '最近3个月',
          type: 'last3Months',
        });
        return [moment().subtract(3, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
      }
    },
    {
      name: 'Last 6 Months',
      nameCN: '最近6个月',
      type: 'last6Months',
      timeType: 'month',
      value: [moment().subtract(6, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
      onClick: () => {
        setFilterSaveDurationFunc({
          name: 'Last 6 Months',
          nameCN: '最近6个月',
          type: 'last6Months',
        });
        return [moment().subtract(6, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
      }
    },
    {
      name: 'Last 12 Months',
      nameCN: '最近12个月',
      type: 'last12Months',
      timeType: 'month',
      value: [moment().subtract(12, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
      onClick: () => {
        setFilterSaveDurationFunc({
          name: 'Last 12 Months',
          nameCN: '最近12个月',
          type: 'last12Months',
        });
        return [moment().subtract(12, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
      }
    },
    {
      name: 'Last 24 Months',
      nameCN: '最近24个月',
      type: 'last24Months',
      timeType: 'month',
      value: [moment().subtract(24, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
      onClick: () => {
        setFilterSaveDurationFunc({
          name: 'Last 24 Months',
          nameCN: '最近24个月',
          type: 'last24Months',
        });
        return [moment().subtract(24, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
      }
    },
    {
      name: 'Year to Date',
      nameCN: '今年',
      type: 'yearToMonth',
      timeType: 'month',
      value: [moment().startOf('year'), moment().endOf('month')],
      onClick: () => {
        setFilterSaveDurationFunc({
          name: 'Year to Date',
          nameCN: '今年',
          type: 'yearToMonth',
        });
        return [moment().startOf('year'), moment().endOf('month')];
      }
    },
  ];

  if (JSON.stringify(latestDate) !== '{}') {
    dateArray = [latestDateData, ...dateArray];
    weekArray = [latestWeekData, ...weekArray];
    monthArray = [latestMonthData, ...monthArray];
  }
  if (startOfTime != '') {
    dateArray = [...dateArray, allDateOfTime];
    weekArray = [...weekArray, allWeekOfTime];
    monthArray = [...monthArray, allMonthOfTime];
  }

  return {
    'date': dateArray,
    'week': weekArray,
    'month': monthArray,
  };
};
